// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"192":"5fdbb811","304":"80f31b4e","626":"efcaaff0"}[chunkId] + ".chunk.js";
};